import { Injectable } from '@angular/core';
import { ApiService, HttpMethod } from '../common/api.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Product } from './product.model';
import { ItemsCollection } from '../common/items-collection.model';
import { Tenant } from './tenant.model';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class TenantApiService extends ApiService
{
   constructor(http: HttpClient)
    {
        super(http);
    }

    getAllTenants(): Observable<Tenant[]>
    {
        return this.apiRequest(this.getAllTenantsUrl, HttpMethod.Get).pipe(map((json: any) => json.Items.map((item: any) => new Tenant(item))));
    }

    getAllProducts(): Observable<Product[]>
    {
        return this.apiRequest(this.getAllProductsUrl, HttpMethod.Get).pipe(map((json: any) => json.Items.map((item: any) => new Product(item))));
    }

    getProduct(): Observable<Product>
    {
        return this.apiRequest(this.getProductUrl, HttpMethod.Get).pipe(map((json:any) => new Product(json)));
    }

    // =========================================================================================================================================================
    // URLs
    // =========================================================================================================================================================
    /* tslint:disable:member-ordering */
    private get baseTenantsApiUrl(): string { return `${this.baseApiUrl}tenants`; }
    get getAllTenantsUrl(): string { return `${this.baseTenantsApiUrl}`; }
    get getAllProductsUrl(): string { return `${this.baseTenantsApiUrl}/products`; }
    get getProductUrl(): string { return `${this.baseTenantsApiUrl}/product`; }
}
